import { render, staticRenderFns } from "./examInquiry.vue?vue&type=template&id=643aee17&scoped=true"
import script from "./examInquiry.vue?vue&type=script&lang=js"
export * from "./examInquiry.vue?vue&type=script&lang=js"
import style0 from "./examInquiry.vue?vue&type=style&index=0&id=643aee17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643aee17",
  null
  
)

export default component.exports